/**
 * @generated SignedSource<<5e4ce1fc46edb1cc28c82f9076b3f2c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CategorizeStakeholderInputObject = {
  allocations: ReadonlyArray<CategorizationAllocationInputObject>;
  perspectiveId: string;
  stakeholderId: string;
};
export type CategorizationAllocationInputObject = {
  amountCents?: number | null | undefined;
  categoryId: string;
  ordinal?: number | null | undefined;
  sliceType?: string | null | undefined;
  weight?: number | null | undefined;
};
export type categorizePage_CategorizeStakeholderMutation$variables = {
  input: CategorizeStakeholderInputObject;
};
export type categorizePage_CategorizeStakeholderMutation$data = {
  readonly categorizeStakeholder: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type categorizePage_CategorizeStakeholderMutation = {
  response: categorizePage_CategorizeStakeholderMutation$data;
  variables: categorizePage_CategorizeStakeholderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizePage_CategorizeStakeholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CategorizeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "categorizeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categorizePage_CategorizeStakeholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CategorizeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "categorizeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7953302f4095d191f88d4ebf234b0464",
    "id": null,
    "metadata": {},
    "name": "categorizePage_CategorizeStakeholderMutation",
    "operationKind": "mutation",
    "text": "mutation categorizePage_CategorizeStakeholderMutation(\n  $input: CategorizeStakeholderInputObject!\n) {\n  categorizeStakeholder(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48e9debe6125ee3816c1309ed5df6228";

export default node;
